var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubAccount = function SvgSubAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 13.333h-3.333V12.5h-.833v4.167h.833v-.834h3.333v3.334h-3.333v-.834h-2.5v-7.5h2.5V10h3.333zm-7.5 5H1.663v-1.666a5 5 0 0 1 5-5h4.167zM9.165 1.667a4.166 4.166 0 1 1 0 8.332 4.166 4.166 0 0 1 0-8.332"
  })));
};
export default SvgSubAccount;